import { ColumnMapping, ExcelProcessorConfig, HeaderConfig, ParsedExcelData, ValidationError } from '@/lib/excel';
import { ImportBody } from './types';

export * from './types';

export const HEADERS = {
  MA_NX: 'Mã nhập xuất',
  TEN_NX: 'Tên nhập xuất',
  TAI_KHOAN: 'Tài khoản',
  TRANG_THAI: 'Trạng thái'
} as const;

const HEADER_CONFIG: HeaderConfig[] = [
  { header: HEADERS.MA_NX, key: 'ma_nx', type: 'main' },
  { header: HEADERS.TEN_NX, key: 'ten_nx', type: 'main' },
  { header: HEADERS.TAI_KHOAN, key: 'tk', type: 'main' },
  { header: HEADERS.TRANG_THAI, key: 'status', type: 'main' }
];

const UUID_FIELDS = {
  main: ['tk']
};
type ExcelSection = Record<string, unknown[]>;
type UUIDLookupResponse = Partial<Record<'main', ExcelSection>>;

const toStringOrNull = (value: unknown): string | null => {
  if (value === null || value === undefined) return null;
  const str = String(value).trim();
  return str === '' ? null : str;
};

const parseStatus = (value: unknown): number => {
  if (value === null || value === undefined || String(value).trim() === '') {
    return 1;
  }
  const num = Number(value);
  return isNaN(num) ? 1 : num;
};

const getFieldName = (key: string) => {
  const config = HEADER_CONFIG.find(c => c.key === key);
  return config?.header?.replace('*', '').trim() || key;
};

const UUIDPayload = (data: ParsedExcelData) => {
  const build = (section: ExcelSection, fields: string[]) =>
    Object.fromEntries(fields.map(f => [f, section?.[f] || []]));

  const main = data.main || {};

  const result = {
    main: build(main, UUID_FIELDS.main)
  };

  return result;
};

const ValidateUUID = (
  response: UUIDLookupResponse | null | undefined,
  columnMapping: Record<string, ColumnMapping>
): ValidationError[] => {
  if (!response) return [];
  const errors: ValidationError[] = [];

  (['main'] as const).forEach(section => {
    const data = response[section];
    if (!data) return;

    Object.entries(data).forEach(([field, values]) => {
      if (!Array.isArray(values)) return;
      const mapping = Object.values(columnMapping).find(m => m.key === field && m.type === section);

      values.forEach((val, i) => {
        if (val === null) {
          errors.push({
            row: i + 2,
            field,
            message: `${getFieldName(field)} không hợp lệ`,
            section,
            columnIndex: mapping?.index
          });
        }
      });
    });
  });

  return errors;
};

const TransformToBodies = (
  dataRows: unknown[][],
  parsedData: ParsedExcelData,
  UUIDResponse: UUIDLookupResponse,
  context: unknown
): ImportBody[] => {
  const main = parsedData.main || {};
  const rowCount = (main.ma_nx || []).length;

  const bodies: ImportBody[] = [];

  for (let i = 0; i < rowCount; i++) {
    const body: ImportBody = {
      ma_nx: toStringOrNull(main.ma_nx?.[i] ?? '') || '',
      ten_nx: toStringOrNull(main.ten_nx?.[i] ?? '') || '',
      tk: ((UUIDResponse.main?.tk && UUIDResponse.main.tk[i]) || toStringOrNull(main.tk?.[i] ?? '')) as string | null,
      status: parseStatus(main.status?.[i])
    };

    bodies.push(body);
  }

  console.log('✅ [DEBUG] Generated bodies:', bodies);
  return bodies;
};

export const ExcelConfig: ExcelProcessorConfig<ImportBody> = {
  Headers: HEADERS,
  HeaderConfig: HEADER_CONFIG,
  Transform: TransformToBodies,
  UUIDPayload,
  ValidateUUID
};
